import { useQuery } from "@apollo/client"
import { GetStatesQuery, GetStatesQueryVariables } from "../generated/graphql"
import { GET_STATES } from "../graphql/queries"

export const useStatesQuery = () => {
  const results = useQuery<GetStatesQuery, GetStatesQueryVariables>(GET_STATES)
  return results
}
